import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from "react";
import DepositInfo from "./DepositInfo";
import WithdrawalInfo from "./WithdrawalInfo";
var TxnInfoBlock = function (_a) {
    var info = _a.info;
    var _b = React.useState(""), timeRemaining = _b[0], setTimeRemaining = _b[1];
    var isDeposit = info.kind === "deposit";
    React.useEffect(function () {
        if (isDeposit) {
            setTimeRemaining("");
            return;
        }
        var expiredAt = info.expired_at;
        if (!expiredAt)
            return;
        var calculateTimeRemaining = function () {
            var now = new Date().getTime();
            var expiry = new Date(expiredAt).getTime();
            var difference = expiry - now;
            if (difference <= 0) {
                setTimeRemaining("Expired");
                return;
            }
            var hours = Math.floor(difference / (1000 * 60 * 60));
            var minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((difference % (1000 * 60)) / 1000);
            if (hours > 0) {
                setTimeRemaining("".concat(hours, "h ").concat(minutes, "m ").concat(seconds, "s"));
            }
            else if (minutes > 0) {
                setTimeRemaining("".concat(minutes, "m ").concat(seconds, "s"));
            }
            else {
                setTimeRemaining("".concat(seconds, "s"));
            }
        };
        calculateTimeRemaining();
        var interval = setInterval(calculateTimeRemaining, 1000);
        return function () { return clearInterval(interval); };
    }, [info.expired_at, isDeposit]);
    var showUnExpiredContent = useMemo(function () {
        return isDeposit
            ? true
            : info.status === "completed"
                ? true
                : timeRemaining !== "Expired";
    }, [isDeposit, timeRemaining]);
    if (!info) {
        return _jsx("div", { children: "Loading..." });
    }
    // Route to appropriate component based on transaction type
    if (isDeposit) {
        return (_jsx(DepositInfo, { info: info, timeRemaining: timeRemaining, showUnExpiredContent: showUnExpiredContent }));
    }
    return (_jsx(WithdrawalInfo, { info: info, timeRemaining: timeRemaining, showUnExpiredContent: showUnExpiredContent }));
};
export default TxnInfoBlock;
